import { render, staticRenderFns } from "./CapturaDocumentos.vue?vue&type=template&id=8b657d38&scoped=true&"
import script from "./CapturaDocumentos.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentos.vue?vue&type=style&index=0&id=8b657d38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b657d38",
  null
  
)

export default component.exports